import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import { useEffect, useState } from 'react';
import api from '../../lib/api';
import { usePublicData } from '../../lib/publicData';
import catalog from '../../generated/light-sheets-catalog.json';
import { shopCopy } from './shopCopy';

export const shopProducts = catalog.products;
export function useShop() {
  const initial = usePublicData()?.pdf_shop_catalog;
  const [liveCatalog, setLiveCatalog] = useState(initial || catalog);
  useEffect(() => { let mounted = true; api.get('/pdf-shop/catalog').then(({data}) => { if (mounted) setLiveCatalog(data); }).catch(() => {}); return () => { mounted = false; }; }, []);
  const [params, setParams] = useSearchParams();
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const lang = pathname === '/fiches-lumiere/pt' || pathname.startsWith('/fiches-lumiere/pt/') || params.get('lang') === 'pt' ? 'pt' : 'fr';
  const flash = /^[1-5]$/.test(params.get('flash')) ? Number(params.get('flash')) : 0;
  const update = (key, value) => {
    const next = new URLSearchParams(params);
    if (value) next.set(key, value); else next.delete(key);
    setParams(next, { preventScrollReset: true });
  };
  const prefix = lang === 'pt' ? '/fiches-lumiere/pt' : '/fiches-lumiere';
  const link = id => `${prefix}${id ? `/${id}` : ''}?${params.toString() || `lang=${lang}`}`;
  const setLang = value => {
    const next = new URLSearchParams(params);
    next.set('lang', value);
    const suffix = pathname.replace(/^\/fiches-lumiere(?:\/pt(?=\/|$))?/, '');
    navigate(`/fiches-lumiere${value === 'pt' ? '/pt' : ''}${suffix}?${next.toString()}`, { preventScrollReset: true });
  };
  return { lang, t: shopCopy[lang], flash, link, setLang, setFlash: value => update('flash', value), products: liveCatalog.products, salesEnabled: Boolean(liveCatalog.checkout_enabled) };
}